import React, { useState, useEffect } from 'react';
import RelativeCard from 'components/Cards/RelativeCard';
import ToggleDetail from 'components/ToggleDetail';
import RelativeFormWrapper from 'components/Forms/RelativeFormWrapper';
import { get } from 'services';
import Alerts from 'utils/alerts'
import Spinner from 'react-bootstrap/Spinner'
import { connect } from 'react-redux';
import { SetLoading } from "redux/actions/loadingActions";
import Navigation from "components/Navigation";
import ValidateToken from "components/ValidToken";

const FamilyStructureModule = ({ user, SetLoading}) => {
  const [showDetail, setShowDetail] = useState(true);
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    (async function mounted() {
      try {
        setIsLoading(true);
        const response = await get(`PersonaFamilia/GetByPersonaId/${user.persona.id}`);
        user.persona.personaFamilias = response.data;
        if (user.persona.personaFamilias && user.persona.personaFamilias.length > 0 && user.persona.personaFamilias.filter(x => x.estado != 0).length > 0) {
          setShowDetail(true);
        } else {
          setShowDetail(false);
        }

        setData(user.persona.personaFamilias);
      } catch (error) {
        Alerts.operationFail();
      } finally {
        setIsLoading(false);
      }
    })();
  }, [])

  return (
    <>
      <ValidateToken/>
      <div className={''}>
        {
          isLoading &&
          <div className={'display-flex flex-direction-row flex-center'}>
              <Spinner 
                animation="grow" 
                variant="primary" 
                className={'is-absolute center-spinner-vertically'} 
                size="lg" />
          </div>
        }
        <ToggleDetail initState={showDetail} onToggleDetail={setShowDetail} label="Estructura familiar"/>
        { 
          showDetail ? 
          <div> 
            <RelativeCard data={data}/>
            <br/>
            <Navigation beforeUrl="/" continueUrl="/vehicle" />
          </div>
          : 
          <div> 
            <RelativeFormWrapper data={data}/>
          </div>
        }
      </div>
    </>
  )
}

const mapStateToProps = (state) => {
  return {
      user: state.user
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    SetLoading: (value) => dispatch(SetLoading(value))
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(FamilyStructureModule);
